export { default as KeyboardAvoidingView } from './KeyboardAvoidingView';
export type { KeyboardAvoidingViewProps } from './types';
